import React from 'react'
import '~/tailwind-output.css'
import AdminLayout from '~/templates/AdminLayout'
import PublicKioskContent from '~/organisms/PublicKiosk/PublicKioskContent'

const PublicKioskPage = ({ kioskData = {}, assets = {}, announcements }) => {
  return (
    <AdminLayout contextValue={{ kioskData, assets }} wrapperClassName='wrapper__inner' announcements={announcements}>
      <PublicKioskContent />
    </AdminLayout>
  )
}

export default PublicKioskPage
